<template>
  <header id="header" class="alt">
    <h1>
      <router-link :to="{ name: 'home' }">{{ title }}</router-link>
    </h1>
    <nav>
      <a href="#menu" v-on:click="toggleMenu">Menu</a>
    </nav>
  </header>
</template>

<script setup lang="ts">
import { onMounted, onUnmounted } from 'vue';

const title = import.meta.env.VITE_TITLE;

function handleScroll() {
  if (window.scrollY > 300) {
    document.getElementById('header')?.classList.remove('alt');
  } else {
    document.getElementById('header')?.classList.add('alt');
  }
}

function toggleMenu() {
  document.getElementById('body')?.classList.toggle('is-menu-visible');
}

onMounted(() => {
  window.addEventListener('scroll', handleScroll);
});

onUnmounted(() => {
  window.removeEventListener('scroll', handleScroll);
});
</script>
